// Third-party imports
import $ from 'jquery';
import 'parsleyjs';

// Local imports
import * as currency from '../util/currency.js';
import * as constant from '../global/constant.js';
import * as wv from '../global/worldvision.js';

// Module name
export const MODULE_NAME = 'spsh_topup';

// Global var module
export let global_vars = {};

export function initialize(global) {
    if (!isSponsorshipSingle()) {
        return;
    }

    handleTopupChange();
    watchForFormSubmission(global);
    updateTotal();
    displayHeroImage();
    getLineNumber(getChildID(), function(line, item) {
        if (line) {
            $('.sponsorshipForm-topupAmount').val(item.line_price / 100);
        }
    });
}

function handleTopupChange() {
    let topup = $('.sponsorshipForm-topupAmount');
    topup.on('keyup', () => {
        updateTotal();
    });
}

// It is expected that the window browser variable is passed in via the global
// arg
function watchForFormSubmission(global) {
    $('.sponsorshipForm').submit(event => {
        event.preventDefault();
        let valid = $(event.target)
            .parsley()
            .validate();
        if (valid) {
            // Note: the function assigned to the cb property can receive a
            // response object as a function arg
            let data = {
                childid: getChildID(),
                amount: getTopUpPrice() / 100,
                cb: () => {
                    addSponsorship(() => {
                        global.location = '/cart';
                    });
                },
            };
            editTopup(global, data);
        }
    });
}

function addSponsorship(cb) {
    sponsored(isSponsored => {
        if (isSponsored) {
            cb();
        } else {
            let sponsorshipId = $('.js-data').data('sponsorshipId');
            let props = { id: sponsorshipId };
            props.properties = wv.get_obj('url_params');
            $.post('/cart/add.js', props, cb);
        }
    });
}

function sponsored(cb) {
    let sponsored = false;
    let childid = getChildID();
    $.getJSON('/cart.js', response => {
        // NOte: the callback given to forEach can be given 2 args:
        //    1. item
        //    2. index
        response.items.forEach(item => {
            if (String(item.properties.childid) === String(childid)) {
                if (
                    item.type === 'Child Sponsorship' ||
                    item.type === 'Child Sponsorship Special Event'
                ) {
                    sponsored = true;
                }
            }
        });
        cb(sponsored);
    });
}

function getChildID() {
    // TODO: is this console log important here?
    // console.log($('.js-data').data('childId').trim());
    return $('.js-data')
        .data('childId')
        .trim();
}

// ------------------------------
// Update Total Client-side
// ------------------------------

function updateTotal() {
    let total = getBasePrice() + getTopUpPrice();
    total = currency.format(total, true);
    $('.sponsorshipForm-total').text(total);
}

function getBasePrice() {
    let price = $('.js-data').data('price');
    return parseFloat(price, 10);
}

function getTopUpPrice() {
    let topup = parseFloat($('.sponsorshipForm-topupAmount').val());
    if (!topup) return 0;
    topup *= 100;
    return topup;
}

function isSponsorshipSingle() {
    return (
        $('body').hasClass('template-product') ||
        $('body').hasClass('template-product-sponsorship')
    );
}

// ------------------------------
// Add/Remove Top up
// ------------------------------

// Add a top up if it doesn't exist otherwise edit the existing one
function editTopup(global, params) {
    getLineNumber(params.childid, lineNumber => {
        if (lineNumber) {
            params.lineNumber = lineNumber;
            if (params.amount) {
                handleUpdate(params);
            } else {
                handleRemove(params);
            }
        } else {
            handleAdd(global, params);
        }
    });
}

function handleUpdate(params) {
    let data = {
        line: params.lineNumber,
        quantity: 1,
        properties: {
            type: 'mp',
            childid: params.childid,
            amount: params.amount,
        },
    };
    $.post('/cart/change.js', data, params.cb);
}

function handleRemove(params) {
    let data = {
        line: params.lineNumber,
        quantity: 0,
    };
    $.post('/cart/change.js', data, params.cb);
}

function handleAdd(global, params) {
    let data = {
        id: constant.get_variantid(global, constant.VariantKind.Topup),
        quantity: 1,
        properties: {
            type: 'mp',
            childid: params.childid,
            amount: params.amount,
        },
    };
    $.post('/cart/add.js', data, params.cb);
}

function getLineNumber(childid, cb) {
    $.getJSON('/cart.js', response => {
        let lineNumber = 0;
        let cartItem = {};
        response.items.forEach((item, index) => {
            if (String(item.properties.childid) === String(childid)) {
                lineNumber = index + 1;
                cartItem = item;
            }
        });
        cb(lineNumber, cartItem);
    });
}

// ------------------------------
// Display Hero Image
// ------------------------------

function displayHeroImage() {
    let heroBlock = $('.heroBlock--topUp');
    let countryImageRequest = $.get(heroBlock.data('countryImage'));

    countryImageRequest.done(() => {
        heroBlock.addClass('heroBlock--fadeDown');
        heroBlock.css(
            'background-image',
            `url(${heroBlock.data('countryImage')})`
        );
    });

    countryImageRequest.fail(() => {
        heroBlock.addClass('heroBlock--fadeDown');
        heroBlock.css(
            'background-image',
            `url(${heroBlock.data('regionImage')})`
        );
    });
}
